import axios from 'axios';

import {
    TOGGLE_SPECIFICATION_SLIDER,
    RESET_FORM_DATA,
    SAVE_CUSTOM_ATTRIBUTE_DATA,
    UPDATE_SPECIFICATION_DATA,
    HANDLE_ON_INPUT_CHANGE,
    UPDATE_BRAND_MANUFACTURE_DATA,
    SET_INITIAL_DATA,
    UPDATE_VARIANT_SPEC,
    CONTENT_UNIT_HANDLE_CHANGE,
    RESET_CONTENT_UNIT_DATA,
    RESET_SPEC_ERRORS,
    SETPSVINFODATA,
} from './types';

import { updateItemInfo } from './items';
import { setSession } from './index';
import { initState } from '../reducers/brandManufacturesReducer';
import { initialState } from '../reducers/productSpecificationReducer';
import { addRemoveSpecVariant, getPsvDetails, updateEditProductDetail } from './products';

const updateSpecificationData = (payload) => ({
        type: UPDATE_SPECIFICATION_DATA,
        payload
    })

const updateBrandManufactureDetails = (payload) => (dispatch,getState) => {
    const updatedValue = getState().brandManufacturer;
    dispatch({
    type: UPDATE_BRAND_MANUFACTURE_DATA,
    payload: {...updatedValue,...payload}
    })
};

const updateContentUnitPerPiece = (payload) => ({
    type: CONTENT_UNIT_HANDLE_CHANGE,
    payload
})

const resetBrandManufactureData = (payload) => ({
    type: SET_INITIAL_DATA,
    payload
})

const checkAndReset = () => (dispatch,getState) => {
    const {
        brandManufacturer,
    } = getState();
    const {
        manufactured_details,
        manufacturer,
        sendDetails
    } = brandManufacturer;
    resetBrandManufactureData();
    if(manufactured_details && manufacturer) {
        updateBrandManufactureDetails({
            ...initState,
            manufactured_details,
            manufacturer,
            sendDetails: [...initState.sendDetails.map(cur => {
                if(['manufactured_details','manufacturer','importer','importers_detail'].includes(cur.name)){
                    cur = sendDetails.find(el => (el.name === cur.name));
                }
            })]
        })
    }
}

const convertRetainSpecs = (newSpecs = {}) => (dispatch,getState) => {
    const {
        productSpecification,
        products
    } = getState();
    console.log('ConvertRetainSpec')
    if(productSpecification.prevCatSpec && productSpecification.prevCatSpec.prevCatSpec) {
    let {
        initPuvSpecAttributes,
        editablePuvSpecAttributes,
        savedPuvSpecAttributes,
        savedCustomSpecAttributes
    } = newSpecs;
    let {
        initPuvSpecAttributes : oldInitPuv,
        editablePuvSpecAttributes : oldEditPuv,
        savedPuvSpecAttributes : oldSavedPuv,
        savedCustomSpecAttributes : oldSavedCustom
    } = productSpecification?.prevCatSpec?.prevCatSpec || {};
    if(oldInitPuv?.length || oldSavedPuv?.length) {

        let newCustom = [];
        let puvList = oldSavedPuv?.length ? oldSavedPuv : oldInitPuv;
        let newSpeclist = [...savedPuvSpecAttributes?.length ? savedPuvSpecAttributes : initPuvSpecAttributes];
        if(puvList?.length){
            puvList.map(cur => {
                if(cur.userInput.value) {
                    let spec = newSpeclist.find(el => el.s_dnm.toLowerCase() === cur.s_dnm.toLowerCase());
                    if(spec && spec.s_type != 'Fixed'){
                        if(spec.s_type == 'DropdownAutosuggest') {
                            let valueInList = spec.s_type_options.find(el => el.toLowerCase() == cur.userInput.value.toLowerCase());
                            valueInList = valueInList || spec.s_type_options.find(el => el.toLowerCase().includes('other')) || '';
                            if(valueInList.toLowerCase().includes('other')){
                                spec.userInput.textboxValue = cur.userInput.textboxValue || cur.userInput.value;
                                spec.textBoxIsHidden = true;
                            }
                            spec.userInput.value = valueInList;
                        }else {
                            spec.userInput.value = cur.userInput.value.toLowerCase().includes('other') ? cur.userInput.textboxValue : cur.userInput.value;
                        }
                    }else if(cur.s_id.toString() != '122') {
                        newCustom.push({
                            key: {value: cur.s_dnm},
                            value: {value: cur.userInput.value+(cur.s_unit?.length? ' '+cur.s_unit[0]:'')}
                        })
                    }
                }})
            }
            if(oldSavedCustom?.length) {
                oldSavedCustom.map(cur => {
                    let spec = newSpeclist.find(el => el.s_dnm?.toLowerCase() === cur.key.value.toLowerCase());
                    if(spec && spec.s_type != 'Fixed'){
                        const reg = new RegExp(spec.s_regexp);
                        if((reg && reg.test(cur.value.value)) || !reg) {
                            spec.userInput.value = cur.value.value;
                            oldSavedCustom = oldSavedCustom.filter(el => el.key.value.toLowerCase() != cur.key.value.toLowerCase())
                        }
                    }
                })
                newCustom.push(...oldSavedCustom);
            }
            let specification = {
                initPuvSpecAttributes: newSpeclist,
                editablePuvSpecAttributes: newSpeclist,
                savedPuvSpecAttributes: newSpeclist,
                s_mandatoryPresent: newSpecs.s_mandatoryPresent,
                re_mandatoryPresent: newSpecs.re_mandatoryPresent,
                savedCustomSpecAttributes: newCustom,
                installationFlag: newSpecs.installationFlag,
                expiryFlag: newSpecs.expiryFlag,
                lbl_img_mandatory: newSpecs.lbl_img_mandatory
            }
    
            dispatch(updateSpecificationData(specification));
            dispatch(updateEditProductDetail([{
                key: 'countryOrigin',
                value: products?.editProduct?.countryOrigin
            }]))
        }
    }
}

const prefillSpecsForService = (isGenericProduct=false) => (dispatch,getState) => {
    const state = getState();
    const detailsSpecs = state.products.editProduct.detailsSpecification;
    const dataToUpdate = [...state.productSpecification.editablePuvSpecAttributes];
    detailsSpecs.map(d_el => {
        let elementInSpec = dataToUpdate.find(el => el.s_id == d_el.sid);
        if(elementInSpec){
            switch(elementInSpec.s_type.toLowerCase()) {
                case "checkboxautosuggest":
            case "checkbox":
                elementInSpec.userInput = {
                    value: d_el ? getCheckboxMapped(newItem, d_el.value) : '',
                    error: "",
                    sunit: d_el?.su
                }

                if(elementInSpec.userInput.value && Array.isArray(elementInSpec.userInput.value)) {
                    if(elementInSpec.s_type_options.some(i => i.toLowerCase().includes("other") && elementInSpec.userInput.value.filter(el => el.label.toLowerCase().includes('other') && !!el.checked))){
                        elementInSpec.userInput.textboxValue = d_el && d_el.sdv.pop() || "";
                        elementInSpec.userInput.textboxError = "";
                        elementInSpec.isDependentTextBox = true;
                        elementInSpec.textBoxIsHidden = !!elementInSpec?.userInput?.textboxValue ;
                    }
               }

                break;

            case "dropdown":
            case "dropdownautosuggest":
                const dropdownVals = d_el && [d_el.sdv] || [];
                elementInSpec.userInput = {
                    value: dropdownVals.length && dropdownVals[0],
                    error: "",
                    sunit: d_el?.su
                }
                if(elementInSpec.s_type_options.some(i => i.toLowerCase().includes("other"))){
                    elementInSpec.userInput.textboxError = "";
                    elementInSpec.userInput.textboxValue = dropdownVals.length > 1 ? dropdownVals[1] : "";
                    elementInSpec.isDependentTextBox = true;
                    elementInSpec.textBoxIsHidden = !!elementInSpec?.userInput?.textboxValue;
                }
                break;

            case "textbox":
            case "textboxautosuggest":
            case "textarea":
                elementInSpec.userInput = {
                    value: isNaN(d_el.su ? d_el.snv.toString() : d_el.sdv.toString()) ? d_el.su ? d_el.snv.toString() : d_el.sdv.toString() : Number(d_el.su ? d_el.snv.toString() : d_el.sdv.toString()),
                    error: "",
                    sunit: d_el?.su
                };

                if(elementInSpec.s_subType || (!elementInSpec.s_type_options?.length && d_el?.su && d_el.su != 'Unit')){
                    elementInSpec.userInput = {
                        ...elementInSpec.userInput,
                        textboxError:"",
                        textboxValue: d_el ? d_el.su : ""
                    }
                }
                break;

            case "rangebox":
                elementInSpec.userInput = {
                    value: d_el && d_el.sdv && Array.isArray(d_el.sdv) && d_el.sdv.length ? d_el.sdv[0]: "",
                    error: "",
                    textboxError: "",
                    textboxValue: d_el && d_el.sdv && Array.isArray(d_el.sdv) && d_el.sdv.length ? d_el.sdv[1]: ""
                }
                break;

            case "unitbox":
                elementInSpec.userInput = {
                    value: d_el ? d_el.sdv.toString() : "",
                    error: "",
                    textboxError:"",
                    textboxValue: d_el ? d_el.su : ""
                }
                break;
            }
        }
    })
    if (isGenericProduct){
        dispatch({
            type: UPDATE_SPECIFICATION_DATA,
            payload: {
                ...state.productSpecification,
                editablePuvSpecAttributes: dataToUpdate,
                savedPuvSpecAttributes: dataToUpdate
            }
        })
    }
}

const getConvertedSpecFormat = (data) => {
    return data.reduce((newFormat, item)=> {
        const newItem = JSON.parse(JSON.stringify(item));
        let userInput = {
            value: "",
            error: ""
        };
        newItem.textBoxIsHidden = false;
        newItem.isDependentTextBox = false;
        switch (newItem.s_type.toLowerCase()){
            case "textbox":
                if(newItem.s_unit.length > 1){
                    newItem.s_subType = "UnitboxWithDropdown";
                    userInput = {
                        ...userInput,
                        textboxValue: "",
                        textboxError: ""
                    }
                }else if(newItem.s_unit.length == 1){
                    newItem.s_subType = "UnitboxWithFixedbox";
                }
                if(["price", "country_of_origin"].includes(newItem.s_nm.toLowerCase())){
                    newItem.textBoxIsHidden = true;
                }
            break;

            case "checkbox":
            case "checkboxautosuggest":
            case 'dropdownautosuggest':
            case "dropdown":
                if(
                    ["checkbox", "dropdown",'dropdownautosuggest'].includes(newItem.s_type.toLowerCase()) &&
                    newItem.s_type_options.some(i => i.toLowerCase().includes('other'))
                ){
                    userInput = {
                        ...userInput,
                        textboxValue: "",
                        textboxError: ""
                    };
                    newItem.isDependentTextBox = true;
                }
                break;
            case "rangebox": {
                userInput = {
                    ...userInput,
                    textboxValue:"",
                    textboxError:"",
                }
            }
        }
        newItem.userInput = userInput;

        newFormat.push(newItem);
        return newFormat;
    }, []);
}

function getPreDefinedCustomAttirubutes(data,apiData){
    let filteredData = [];
    let ignoreSpecList = ['3848','122'];
    data.map(i => {
        let specData = ignoreSpecList.includes(i.sid.toString()) ? i : apiData.find(el => el.s_id.toString() === i?.sid?.toString());
        if(i.isCustom == 1 || !specData) {//|| !ignoreSpecList.includes(i.sid).toString()
            filteredData.push({
                ...i,
                name: i.displayName ? i.displayName : i.name,
                isCustom: 1
            });
        }
    });

    return filteredData && filteredData.reduce((newData, item) => {
        newData.push({key: { value: item.name, error: ""}, value:{ value: item.value.toString(), error: ""},sid: item.sid});
        return newData;
    }, []);
}

function getPredefinedPuvMapped(data, readyData){
    const newData = [] ;

    const getCheckboxMapped = (item, value) => {
        const mappedValue = value;
        let mapped = mappedValue.reduce((acc, el, indx) => {

            if(!item.s_type_options.includes(el) && item.s_type.toLowerCase() == "checkbox"){
                return acc;
            }

            acc.push({
                label: el,
                checked : true,
                key: indx
            })
            return acc;
        }, []);
        const otherOptions = item.s_type_options.reduce((ac, el , indx) => {
            const isPresent = mapped.some(e => el == e.label);
            if(!isPresent){
                ac.push({
                    label: el,
                    checked: false,
                    key: indx
                });
            }else {
                mapped = mapped.filter(cur => cur != isPresent);
            }        
            return ac;
        }, []);
        const isOtherOption = item.s_type_options.filter(cur => cur.toLowerCase().includes('other'));
        let finalArr = [...mapped, ...otherOptions];
        if(mapped.length && isOtherOption) {
            finalArr = finalArr.map(el => {
                if(el.label == isOtherOption[0]) {
                    el.checked = true;
                }
                return el;
            })
        }
        return finalArr;
    }

    data.forEach(item => {
        const readyItem = readyData.filter(i => i.sid == item.s_id).pop();
        const newItem = {...item};

        switch(newItem.s_type.toLowerCase()){
            case "checkboxautosuggest":
            case "checkbox":
                newItem.userInput = {
                    value: readyItem ? getCheckboxMapped(newItem, readyItem.value) : '',
                    error: "",
                    sunit: readyItem?.sunit
                }

                if(newItem.userInput.value && Array.isArray(newItem.userInput.value)) {
                    if(newItem.s_type_options.some(i => i.toLowerCase().includes("other") && newItem.userInput.value.filter(el => el.label.toLowerCase().includes('other') && !!el.checked))){
                        newItem.userInput.textboxValue = readyItem && readyItem.value.pop() || "";
                        newItem.userInput.textboxError = "";
                        newItem.isDependentTextBox = true;
                        newItem.textBoxIsHidden = !!newItem?.userInput?.textboxValue;
                    }
               }

                break;

            case "dropdown":
            case "dropdownautosuggest":
                const dropdownVals = readyItem && readyItem.value || [];
                newItem.userInput = {
                    value: dropdownVals.length && dropdownVals.toString(),
                    error: "",
                    sunit: readyItem?.sunit
                }
                if(newItem.s_type_options.some(i => i.toLowerCase().includes("other"))){
                    newItem.userInput.textboxError = "";
                    newItem.userInput.textboxValue = "";
                    newItem.isDependentTextBox = true;
                    newItem.textBoxIsHidden = !!newItem?.userInput?.textboxValue;
                }
                break;

            case "textbox":
            case "textboxautosuggest":
            case "textarea":
                newItem.userInput = {
                    value: readyItem ? readyItem.value.toString() : "",
                    error: "",
                    sunit: readyItem?.sunit
                };

                if(newItem.s_subType || (!newItem.s_type_options?.length && readyItem?.unit && readyItem.unit != 'Unit')){
                    newItem.userInput = {
                        ...newItem.userInput,
                        textboxError:"",
                        textboxValue: readyItem ? readyItem.unit : ""
                    }
                }
                break;

            case "rangebox":
                newItem.userInput = {
                    value: readyItem && readyItem.value && Array.isArray(readyItem.value) && readyItem.value.length ? readyItem.value[0]: "",
                    error: "",
                    textboxError: "",
                    textboxValue: readyItem && readyItem.value && Array.isArray(readyItem.value) && readyItem.value.length ? readyItem.value[1]: ""
                }
                break;

            case "unitbox":
                newItem.userInput = {
                    value: readyItem ? readyItem.value.toString() : "",
                    error: "",
                    textboxError:"",
                    textboxValue: readyItem ? readyItem.unit : ""
                }
                break;

            case "fixed":
                newItem.userInput = {
                    value: readyItem ? readyItem.value.toString() : "",
                    error: "",
                    textboxError: "",
                    textboxValue: ""
                }
                break;
            case "date":
                newItem.userInput = {
                    value: readyItem ? readyItem.value.toString() : ""
                }
                break;

        }
        newItem.aiSpec = readyItem?.aiSpec || false;
        newData.push(newItem);
    });

    return newData;
}

const fetchSpecificationAttributes = (id, preDefinedData, options={},brandManufacturer = null) => (dispatch, getState) => {
    const state = getState();
    const token = state.session.token;
    const supplierId = state.session.supplierId;
    const isService = state.products.editProduct.categoryType == 'service';
    let URL = `/vendorapis/products/product/fetchProductSpecsData?keywordid=${id}&supplierId=${supplierId}&display_Flag=1`;
    if(options?.isTemp){
        URL = `/vendorapis/products/product/fetchProductSpecsData?psv_node_id=${options.leafId}&brandid=${options.bid}&display_Flag=1`;
        if (options?.isEnrich) {
            let specIds = preDefinedData?.length?preDefinedData.map(cur => (cur.sid)):null;
            if (specIds) {
                URL += `&specid=${specIds?.toString()}`;
            }
        }else if(options?.specIds) {
            URL += `&specid=${options.specIds?.toString()}`;
        }
    }
    if(options?.specIds) {
        URL += `&specid=${options.specIds?.toString()}`;
    }
    if(options?.jdmartids){
        URL += `&jdmid=${options.jdmartids}`;
    }
    if (options?.isEnrich) {
        URL += '&forEnrich=true';
    } else {
        URL += `&token=${token}&supplierId=${supplierId}`;
    }
    axios.get(URL).then( async res => {
        if(res.data && res.data.data) {
            if(res.data.businessType) {
                dispatch(updateItemInfo({
                    isBisType: res.data.isBisType ? true : false,
                    businessTag: res.data.businessType,
                }));

                !options.isTemplate && dispatch(setSession({
                    businessType: res.data.businessType
                }));
            } else {
                !options.isTemplate && dispatch(setSession({
                    businessType: ""
                }));
            }
            if(state.products.editProduct?.psv_node_id || state.products.editProduct?.leafId) {
                const categoryType = state.products.editProduct.categoryType;
                let psvData = {
                   type : categoryType,
                   psv_node_id : state.products.editProduct?.psv_node_id || state.products.editProduct?.leafId
               }
               let PsvDetailsUomType = dispatch(getPsvDetails(psvData));
               if(!PsvDetailsUomType) {
                const uomType = categoryType == 'product' ? 'productUom' : 'serviceUom';
                    dispatch({
                        type: SETPSVINFODATA,
                        data: {data: {
                            ...state.products?.psvInfoData,
                            [uomType]: (state.products?.psvInfoData?.[uomType] || []).concat(Array.isArray(res.data.units) ? res.data.units : [res.data.units]),
                        }},
                        mainUOM: state.uom,
                        categoryType: categoryType,
                        psvToSet: res.data.units
                    })
               }
            }
            let convertedData = getConvertedSpecFormat(res.data.data);
            if(preDefinedData && preDefinedData.length){
                if(options?.isEnrich){
                    preDefinedData?.forEach(item=>{
                        item.value=item.sdv;
                    })
                }
                const productCustomMap = await getPreDefinedCustomAttirubutes(preDefinedData,res.data.data);
                let productPuvMap = await getPredefinedPuvMapped(convertedData, preDefinedData)
                let s_mandCount = 0;
                let re_mandCount = 0
                let variantSpec = [];
                let manuFacturerMand = false;
                let brandSpec = [];
                if(options?.isTemp && !isService){
                    brandSpec = convertedData
                    productPuvMap = productPuvMap.filter(el => el.userInput?.value[0])
                }
                productPuvMap.map(cur => {
                    if(!['mrp','brand','manufacturer','manufactured_details','country_of_origin','importer','importers_detail','price','packaging_length','packaging_width','packaging_height','packaging_weight','expiry_date'].includes(cur.s_nm.toLowerCase())
                        && (state.session.viaOmni ? !Number( cur.s_filter_flag) : !Number( cur.s_variant_flag))) {
                    
                         if(Number(cur.s_mandatory) == 1){
                            s_mandCount++;
                         }
                         if(Number(cur.s_re_mandatory) == 1) {
                            re_mandCount++;
                         }
                    }
                    if((state.session.viaOmni ? Number(cur.s_filter_flag) : Number(cur.s_variant_flag)) ){
                        variantSpec.push(cur.s_dnm);
                    }
                    if(cur.s_nm == 'manufacturer' && cur.s_mandatory == 1){
                        manuFacturerMand = true;
                    }

                })
                let sendData = [...state.brandManufacturer.sendDetails];
                sendData.map(cur => {
                  let specElement = productPuvMap.find(el => el.s_nm == cur.name);
                  if(specElement) {
                    cur.sid = specElement.s_id.toString();
                  }
                });
                if(state.products.editProduct.productId != 'ADD_PRODUCT' && state.products.editProduct?.variantCommands) {
                    let convertedData = [...productPuvMap];
                    let data = [];
                    state.variants?.variantData?.map(cur => data.push(cur.type));
                    productPuvMap = convertedData.filter(el => !data.includes(el.s_dnm));
                }
                dispatch({
                    type: UPDATE_VARIANT_SPEC,
                    payload: variantSpec
                })
                // productPuvMap = productPuvMap.filter(el => !variantSpec.includes(el.s_dnm));
                dispatch(updateBrandManufactureDetails({
                    sendDetails: [...sendData],
                    manuFacturerMand,
                    brandSpec: brandSpec,
                    moq_require: Number(res.data.moq_require)
                }))
                let specification = {
                    initPuvSpecAttributes : productPuvMap ,
                    isEnrichSpec:options?.isEnrich,
                    editablePuvSpecAttributes: productPuvMap,
                    savedPuvSpecAttributes: productPuvMap,
                    savedCustomSpecAttributes: productCustomMap,
                    s_mandatoryPresent: re_mandCount,
                    re_mandatoryPresent: s_mandCount,
                    installationFlag: res.data.installation_flag,
                    expiryFlag: res.data.expiry_date_flag,
                    lbl_img_mandatory: res.data.lbl_img_mandatory,
                    growerFlag: res.data?.growerFlag,
                    developerFlag: res.data?.developerFlag
                }
                if(state.products.editProduct.bothAPICalled || options.ignoreAPI) {
                    state.products.editProduct.bothAPICalled = 2;
                }else {
                    state.products.editProduct.bothAPICalled = 1;
                }
                if(!state.products.editProduct.fromKeywordId) {
                    dispatch(updateEditProductDetail({key : 'fromKeywordId',value : !options?.isTemp}))
                }
                dispatch(updateSpecificationData(specification));
                if(!(state?.products?.editProduct?.isTempProd || state?.products?.editProduct?.isTemplate))
                    dispatch(convertRetainSpecs(specification));
                return;
            }
            let s_mandCount = 0;
            let re_mandCount = 0;
            let variantSpec = [];
            let manuFacturerMand = false;
            let brandSpec = [];
            if(options?.isTemp && !isService){
                brandSpec = convertedData
                convertedData = convertedData.filter(cur => ['packaging_width','packaging_height','packaging_length','packaging_weight'].includes(cur.s_nm));
            }
            convertedData.map(cur => {
                if(!['brand','manufacturer','manufactured_details','country_of_origin','importer','importers_detail','price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'].includes(cur.s_nm.toLowerCase())) {
                    if(Number(cur.s_mandatory) == 1){
                        s_mandCount++;
                    }
                    if(Number(cur.s_re_mandatory) == 1){
                        re_mandCount++;
                    }
                }
                if((state.session.viaOmni ? Number(cur.s_filter_flag) : Number(cur.s_variant_flag))){
                    variantSpec.push(cur.s_dnm);
                }
                if(cur.s_nm == 'manufacturer' && cur.s_mandatory == 1){
                    manuFacturerMand = true;
                }
            })
            let sendData = [...state.brandManufacturer.sendDetails];
            sendData.map(cur => {
              let specElement = convertedData.find(el => el.s_nm == cur.name);
              if(specElement) {
                cur.sid = specElement.s_id.toString();
                cur.isCustom = 0;
              }
            })
            if (state.session.viaOmni) {
              const excludeFields = ["Brand", "MRP"];
              variantSpec = variantSpec.filter(
                (item) => !excludeFields.includes(item)
              );
            }
            // convertedData = convertedData.filter(el => !variantSpec.includes(el.s_dnm));
            dispatch({
                type: UPDATE_VARIANT_SPEC,
                payload: variantSpec
            })
            dispatch(updateBrandManufactureDetails({
                sendDetails: [...sendData],
                manuFacturerMand,
                brandSpec: brandSpec,
                moq_require: Number(res.data.moq_require),
            }))
            let specification = {
                initPuvSpecAttributes: convertedData,
                editablePuvSpecAttributes: convertedData,
                s_mandatoryPresent: s_mandCount,
                re_mandatoryPresent: re_mandCount,
                installationFlag: res.data.installation_flag,
                expiryFlag: res.data.expiry_date_flag,
                lbl_img_mandatory: res.data.lbl_img_mandatory,
                growerFlag: res.data?.growerFlag,
                developerFlag: res.data?.developerFlag
            }
            if(state.products.editProduct.bothAPICalled || options.ignoreAPI) {
                state.products.editProduct.bothAPICalled = 2;
            }else {
                state.products.editProduct.bothAPICalled = 1;
            }
            if(!state.products.editProduct.fromKeywordId) {
                dispatch(updateEditProductDetail({key : 'fromKeywordId',value : !options?.isTemp}))
            }
            dispatch(updateSpecificationData(specification));
            if(!(state.products.editProduct.isTempProd || state.products.editProduct.isTemplate))
                dispatch(convertRetainSpecs(specification));
        }
    }).catch(err => {
        console.log(err)
    });
};

const resetContentUnitData = (payload) => ({
    type: RESET_CONTENT_UNIT_DATA,
    payload
})

const toggleSpecificationSlider = (payload) => {
    return ({
        type : TOGGLE_SPECIFICATION_SLIDER,
        payload
    })
};

const resetSpecificationFormData = (payload = null) => ({
    type : RESET_FORM_DATA,
    payload: payload
});

const resetSpecErrors =(payload)=>({
    type: RESET_SPEC_ERRORS,
    payload:payload
})

const handleOnChange = (payload) => {
    return {
        type: HANDLE_ON_INPUT_CHANGE,
        payload
    }
}

export {
    fetchSpecificationAttributes,
    toggleSpecificationSlider,
    resetSpecificationFormData,
    updateSpecificationData,
    updateBrandManufactureDetails,
    handleOnChange,
    resetBrandManufactureData,
    updateContentUnitPerPiece,
    resetContentUnitData,
    resetSpecErrors,
    checkAndReset,
    convertRetainSpecs,
    prefillSpecsForService
}